export default __webpack_public_path__ + "static/media/step1.0a8ff931.svg";